// extracted by mini-css-extract-plugin
export var container = "dF_g";
export var fadeDiv = "dF_gt";
export var placeholderWrapper = "dF_rF";
export var video = "dF_rG";
export var videoWrapper = "dF_jL";
export var vimeoPlayer = "dF_rH";
export var wrapper = "dF_B";